import { memo, type FC } from "react";
import { PressableScale } from "pressto";
import { useUnistyles, StyleSheet } from "react-native-unistyles";
import { View, Text } from "@src/components";
import { Icon } from "@src/components/Icon";

interface ManageAlarmSettingsCardProps {
  onPress: () => void;
}

export const ManageAlarmSettingsCard: FC<ManageAlarmSettingsCardProps> = memo(({ onPress }) => {
  const { theme } = useUnistyles();

  return (
    <PressableScale onPress={onPress}>
      <View style={styles.card}>
        <View flexDirection="row" justifyContent="space-between" alignItems="center">
          <View flexDirection="row" alignItems="center" gap="xs">
            <Icon name="settingsCameraOutline" size={24} color={theme.colors.text} />
            <Text textStyle="sm/medium">Manage alarm settings</Text>
          </View>
          <Icon name="chevronRight" size={24} color={theme.colors.textMuted} />
        </View>
        <View>
          <Text textStyle="xs/regular" color="textMuted">
            Manage your site&apos;s routines, schedule temporary exceptions, and configure alarm responses and
            notifications.
          </Text>
        </View>
      </View>
    </PressableScale>
  );
});

const styles = StyleSheet.create((theme) => ({
  card: {
    padding: theme.spacing["3xl"],
    borderRadius: theme.spacing.md,
    borderWidth: 1,
    borderColor: theme.colors.borderCard,
    backgroundColor: theme.colors.surfaceCard,
    gap: theme.spacing.md,
  },
}));
